import { useTranslation } from "react-i18next";
import styles from "./Achieve.module.css";
import { SectionTitle } from "../../PresentationalComponents/SectionTitle";
import { Award, GraduationCap, Rocket, SquareText, Trophy } from "lucide-react";

const formatter = new Intl.NumberFormat("fa-IR");

const AchivementsDictionary = {
  en: {
    sectionTitle: "Achievements",
    sectionNum: "05",
    achievements: [
      {
        title: "Top 1% ",
        description: "in the 2016 National B.Sc. Entrance Exam",
        image: <GraduationCap className={styles.svg} />,
      },
      {
        title: "Top 300 ",
        description:
          "Nationwide in the 2026 the M.Sc. Computer Engineering Entrance Exam",
        image: <Trophy className={styles.svg} />,
      },
      {
        title: "+10",
        description: "Projects Compeleted",
        image: <Rocket className={styles.svg} />,
      },
      {
        title: "1",
        description: "Research Paper Published",
        image: <SquareText className={styles.svg} />,
      },
    ],
  },
  fa: {
    sectionTitle: "دستاورد‌ها",
    sectionNum: formatter.format("0") + formatter.format("5"),
    achievements: [
      {
        title: formatter.format(1) + "%" + " تاپ",
        description:
          "در کنکور کارشناسی سراسری کارشناسی سال " +
          formatter.format("1") +
          formatter.format("395"),
        image: <GraduationCap className={styles.svg} />,
      },
      {
        title: formatter.format(300) + " تاپ",
        description: "در کنکور سراسری کارشناسی ارشد مهندسی کامپیوتر",
        image: <Trophy className={styles.svg} />,
      },
      {
        title: "+" + formatter.format(10),
        description: "پروژه موفق",
        image: <Rocket className={styles.svg} />,
      },
      {
        title: formatter.format(1),
        description: "مقاله منتشر شده",
        image: <SquareText className={styles.svg} />,
      },
    ],
  },
};

export function Achieve({ t }) {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  return (
    <section className={styles.sectionContainer}>
      <div className={styles.header}>
        <SectionTitle
          text={AchivementsDictionary[lang].sectionTitle}
          num={AchivementsDictionary[lang].sectionNum}
        />
      </div>
      <div className={styles.achievementsContainer}>
        {AchivementsDictionary[lang].achievements.map((achievement, index) => (
          <div className={styles.achievementCard}>
            <div>
              {achievement.image}
              <h4>{achievement.title}</h4>
            </div>
            <p>{achievement.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
